// extracted by mini-css-extract-plugin
module.exports =  {"contactPage":"contactPage___0rikA","content":"content___Hg2nt","ourContacts":"ourContacts___llDe0","contactItem":"contactItem___RFvXK","native":"native___jfIST"};